import React, { useState } from "react"
import * as classNames from "./ArticlesListBlock.module.scss"
import ArticleCardBlock from "../article-card/ArticleCardBlock"
import ArticleLeftRightBlock from "../article-left-right/ArticleLeftRightBlock"
import Button from "../../../common/blocks/button/Button"
import { articleUrl } from "../../../../../utils/routeLib"

function ArticleListBlock({ articles, bigTitle, showPageCount, isAlignLeft, unique }) {
  const [numGroups, setNumGroups] = useState(showPageCount)

  if(!articles) articles = []

  // Split articles into groups of 5

  const articleGroups = articles.reduce((acc, curr, i) => {
    const groupIndex = Math.floor(i / 5)
    if (!acc[groupIndex]) {
      acc[groupIndex] = [curr]
    } else {
      acc[groupIndex].push(curr)
    }
    return acc
  }, [])

  const displayedArticleGroup = articleGroups.slice(0, numGroups)

  const handleLoadMore = () => {
    setNumGroups(numGroups + 1)
  }

  let left = true

  return (
    <>
      {displayedArticleGroup.map((articleGroup, i) => (
        <React.Fragment key={i}>
          <ArticleLeftRightBlock
            bigTitle={i === 0 ? bigTitle : ""}
            url={articleUrl(articleGroup[0])}
            isAlignLeft={isAlignLeft}
            article={articleGroup[0]}
          />
          {!unique && (
          <div className={`${classNames.articleGrid}`}>
            {articleGroup.slice(1).map((article) => (
              <ArticleCardBlock
                key={article.id}
                url={articleUrl(article)}
                articles={article}
              />
            ))}
          </div>
          )}
        </React.Fragment>
      ))}
      {numGroups < articleGroups.length && !unique &&  (
        <div className='flex justify-center pt-8 pb-4'>
          <Button
            onClick={handleLoadMore}
            aspect={"classique"}
            color={"primary"}
          >
            Voir plus
          </Button>
        </div>
      )}
    </>
  )
}
export default ArticleListBlock
